"use strict";
import { useSwapFormContext } from "uniswap/src/features/transactions/swap/contexts/SwapFormContext";
export function useSelectedTokenState() {
  const state = useSwapFormContext();
  return state;
}
